export default "__VITE_ASSET__Yq$3UFWp__"